function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. PLEASE USE APP-COMPONENTS ExpandableContainer INSTEAD.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compact, get, includes, isNull, reduce } from 'lodash';
import { Toggle, Header, ExpandableContent, GradientSvg } from "./components";

/**
 * @visibleName ExpandableContainer DEPRECATED
*/
var ExpandableContainer = /*#__PURE__*/function (_Component) {
  function ExpandableContainer(props) {
    var _this;
    _classCallCheck(this, ExpandableContainer);
    _this = _callSuper(this, ExpandableContainer, [props]);
    _this.getChildHeight = _this.getChildHeight.bind(_this);
    _this.getContentStyle = _this.getContentStyle.bind(_this);
    _this.init = _this.init.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.state = {
      canExpand: false,
      childHeight: 0,
      collapsedHeight: 0,
      open: props.isOpen || false
    };
    return _this;
  }
  _inherits(ExpandableContainer, _Component);
  return _createClass(ExpandableContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.onResize);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({
          open: nextProps.isOpen
        });
      }
      if (nextProps.forceResize && nextProps.forceResize !== this.props.forceResize) {
        this.onResize();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.children !== prevProps.children) {
        this.getChildHeight();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.getChildHeight();
    }
  }, {
    key: "getChildHeight",
    value: function getChildHeight() {
      var useFirstChildHeight = this.props.useFirstChildHeight;
      var child = this.el.querySelector('.expandable-container__content-children');
      var childHeight = child.clientHeight;
      if (useFirstChildHeight) {
        var list = this.el.getElementsByClassName('expandable-container__content-children');
        childHeight = get(list[0], 'childNodes[0].clientHeight', childHeight);
      }
      this.setState({
        canExpand: childHeight > this.state.collapsedHeight,
        childHeight: childHeight
      });
    }
  }, {
    key: "getContentStyle",
    value: function getContentStyle() {
      return {
        height: this.state.open || !this.state.canExpand ? "".concat(this.state.childHeight, "px") : this.props.collapsedHeight
      };
    }
  }, {
    key: "init",
    value: function init() {
      // create a temporary div to compute the real height of the potentially collapsed container
      var contentEl = document.createElement('div');
      var elStyles = "height: ".concat(this.props.collapsedHeight, "; position: absolute;");
      contentEl.setAttribute('style', elStyles);
      this.el.appendChild(contentEl);
      var elHeight = contentEl.clientHeight;
      this.el.removeChild(contentEl);
      this.setState({
        collapsedHeight: elHeight
      }, this.getChildHeight);
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      e.preventDefault();
      if (!this.props.controlled) {
        this.setState({
          open: !this.state.open
        });
      }
      if (this.props.onToggle) {
        this.props.onToggle(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        readOnlyToggleText = _this$props.readOnlyToggleText,
        header = _this$props.header,
        id = _this$props.id,
        lessText = _this$props.lessText,
        moreText = _this$props.moreText,
        style = _this$props.style,
        togglePosition = _this$props.togglePosition,
        hideToggle = _this$props.hideToggle,
        showGradient = _this$props.showGradient;
      var toggleClass = function toggleClass() {
        return classNames({
          'expandable-container__toggle': true,
          open: _this2.state.open,
          hidden: !_this2.state.canExpand
        }, togglePosition);
      };
      var expandableClass = function expandableClass() {
        return classNames({
          'expandable-container__content': true,
          open: _this2.state.open
        });
      };
      var headerEl = header ? /*#__PURE__*/React.createElement(Header, {
        key: header,
        header: header
      }) : null;
      var expandableContent = children ? /*#__PURE__*/React.createElement(ExpandableContent, {
        className: expandableClass(),
        key: "".concat(header, "-content"),
        style: this.getContentStyle()
      }, children) : null;
      var toggleEl = hideToggle ? null : /*#__PURE__*/React.createElement(Toggle, {
        className: toggleClass(),
        id: id,
        key: "".concat(header, "-toggle"),
        onClick: this.toggle,
        open: this.state.open,
        text: this.state.open ? lessText : moreText,
        readOnly: readOnlyToggleText
      });
      var gradientColor = reduce(style, function (acc, value, key) {
        return includes(['background', 'backgroundColor'], key) ? value : acc;
      }, 'white');
      var gradientEl = showGradient && this.state.canExpand ? /*#__PURE__*/React.createElement(GradientSvg, {
        key: "".concat(header, "-gradient"),
        open: this.state.open,
        color: gradientColor,
        id: id
      }) : null;
      var items = compact([headerEl].concat(_toConsumableArray(togglePosition.includes('top') ? [toggleEl, expandableContent, gradientEl] : [expandableContent, gradientEl, toggleEl])));
      return /*#__PURE__*/React.createElement("div", {
        className: "expandable-container",
        id: id,
        ref: function ref(div) {
          _this2.el = div;
        },
        style: style
      }, items.map(function (item) {
        return item;
      }));
    }
  }]);
}(Component);
ExpandableContainer.propTypes = {
  /** Items that are passed to ExpandableContent */
  children: PropTypes.node,
  /** the height of the container while collapsed */
  collapsedHeight: PropTypes.string,
  /** use the height of the first child while collapsed */
  useFirstChildHeight: PropTypes.bool,
  /** boolean that determines if the component toggling is controlled externally */
  controlled: PropTypes.bool,
  /** boolean that resizes the height depending on actions taken (radio, button, etc) */
  forceResize: PropTypes.bool,
  /** header text for component */
  header: PropTypes.string,
  /** id for main component used to build related ids */
  id: PropTypes.string.isRequired,
  /** prop used to determine if the container is open, used in conjunction with onToggle */
  isOpen: function isOpen(props, propName, componentName) {
    // eslint-disable-line consistent-return, func-names, object-shorthand
    if (props.controlled === true && isNull(propName)) {
      return new Error("When the prop 'controlled' is set to true, the '".concat(propName, "' prop for ").concat(componentName, " must be set to control toggling"));
    }
  },
  /** boolean to hide the toggle button, used in conjunction with controlled */
  hideToggle: PropTypes.bool,
  /** toggle text for expanded state */
  lessText: PropTypes.string,
  /** toggle text for collapsed state */
  moreText: PropTypes.string,
  /** function to that is called when the Toggle component is clicked */
  onToggle: PropTypes.func,
  /** boolean to make the toggle text read only or a functional toggle */
  readOnlyToggleText: PropTypes.bool,
  /** styles object, override if feeling adventurous  */
  style: PropTypes.object,
  /** string prop to control where the toggle is rendered in relation to the expanding content */
  togglePosition: PropTypes.oneOf(['left', 'right', 'top-right', 'top-left']),
  /** Boolean value to display or hide gradient */
  showGradient: PropTypes.bool
};
ExpandableContainer.defaultProps = {
  children: null,
  collapsedHeight: '10em',
  controlled: false,
  forceResize: false,
  header: null,
  isOpen: false,
  lessText: 'Read Less',
  moreText: 'Read More',
  onToggle: null,
  style: {},
  togglePosition: 'left',
  hideToggle: false,
  readOnlyToggleText: false,
  showGradient: true,
  useFirstChildHeight: false
};
export default ExpandableContainer;